/**
 * Generate CSV content from call history data.
 */
export function generateCsvContent(
  calledNumbers: number[],
  startTime: string | null
): string {
  const lines: string[] = [];
  lines.push('Order,Number,Time');

  const baseTime = startTime ? new Date(startTime).getTime() : Date.now();

  for (let i = 0; i < calledNumbers.length; i++) {
    const num = calledNumbers[i];
    // Approximate time: we don't store per-number timestamps in this version,
    // but we can at least provide the order number.
    const orderNum = i + 1;
    lines.push(`${orderNum},${num},`);
  }

  return lines.join('\n');
}

/**
 * Trigger a CSV file download in the browser.
 */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob(['\uFEFF' + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
